import axios from 'axios'
import {apiUrl} from '@/api/base.js'

export default {
    delete_post(postArgs) {
        let id = postArgs.post_id;
        return axios.delete(`${apiUrl}v2/delete_post/${id}`)
    },
    modify_post(postArgs) {
        return axios.post(`${apiUrl}v2/modify_post/`, postArgs)
    },
    modify_post_publish_state(postArgs) {
        return axios.post(`${apiUrl}v2/modify_post_publish_state/`, postArgs)
    },
    publish_post(postArgs) {
        return axios.post(`${apiUrl}v2/publish_post/`, postArgs)
    },
    get_post_info(postArgs) {
        return axios.get(`${apiUrl}v2/get_post_info/`, {params: postArgs})
    },
    get_my_posts() {
        return axios.get(`${apiUrl}v2/get_my_posts/`)
    },
    get_explore_posts() {
        return axios.get(`${apiUrl}v2/get_explore_posts/`)
    },
    get_post_column() {
        return axios.get(`${apiUrl}v2/get_post_column/`)
    },
    get_post_reply(args){
        return axios.get(`${apiUrl}v2/get_post_reply/`,{params: args})
    },
    reply_post (args) {
        return axios.post(`${apiUrl}v2/reply_post/`, {'params': args})
    },
    set_column (args) {
        return axios.post(`${apiUrl}v2/set_column/`, {'params': args})
    },
}
